enum TopUpTypes {
  BankTransfer = "BANK_TRANSFER",
  PayWithCard = "PAYMENTS"
}

export default TopUpTypes
